<template>
    <div class="canvas-container">
        <div class="canvas-viewport custom-scrollbar">
            <canvas
                ref="canvasVistaSuperior"
                :style="{ cursor: caboHover.cabo !== null ? 'pointer' : 'default' }"
                @mousemove="onMouseMove"
                @mouseleave="setCaboHover(null)"
            >
                O seu browser não suporta canvas.
            </canvas>
        </div>
    </div>
</template>

<script>
import { caboHover } from "./caboHover";

export default {
    setup() {
        return { caboHover };
    },
    props: {
        cabos: {
            type: Object,
            default: () => ({}),
        },
        silotipo: {
            type: String,
        },
        theme: {
            type: String,
        }
    },
    watch: {
        cabos(newVal) {
            this.renderVistaSuperior(newVal);
        },
        theme() {
            this.renderVistaSuperior(this.cabos);
        },
        'caboHover.cabo'() {
            this.renderVistaSuperior(this.cabos);
        }
    },
    mounted() {
        this.renderVistaSuperior(this.cabos);
    },
    beforeUnmount() {
        this.setCaboHover(null);
    },
    methods: {
        onMouseMove(event) {
            const canvas = this.$refs.canvasVistaSuperior;
            if (!canvas || !this.hitAreas || !this.tamanhoLogico) return;
            const rect = canvas.getBoundingClientRect();
            const x = (event.clientX - rect.left) * this.tamanhoLogico.largura / rect.width;
            const y = (event.clientY - rect.top) * this.tamanhoLogico.altura / rect.height;
            const alvo = this.hitAreas.find((a) => Math.hypot(a.x - x, a.y - y) <= a.r + 3);
            const cabo = alvo ? Number(alvo.cabo) : null;
            if (caboHover.cabo !== cabo) this.setCaboHover(cabo);
        },
        setCaboHover(cabo) {
            caboHover.cabo = cabo;
            caboHover.origem = cabo === null ? null : 'vista';
        },
        drawCabo(ctx, cabo, x, y, dotRadius, color) {
            const hover = caboHover.cabo;
            const ativo = hover !== null && Number(cabo) === hover;
            ctx.save();
            if (hover !== null && !ativo) ctx.globalAlpha = 0.3;
            if (ativo) this.drawFillCircle(ctx, x, y, dotRadius + 3, "white");
            this.drawFillCircle(ctx, x, y, dotRadius, color);
            this.drawCaboLabel(ctx, cabo, x, y, dotRadius);
            ctx.restore();
            this.hitAreas.push({ cabo, x, y, r: dotRadius });
        },
        drawText(ctx, text, x, y, fontSize) {
            ctx.font = `${fontSize}px Arial`;
            ctx.fillStyle = "white";
            ctx.textAlign = "center";
            ctx.textBaseline = "middle";
            ctx.fillText(text, x, y);
            ctx.textAlign = "start";
            ctx.textBaseline = "alphabetic";
        },
        degreeToRadians(angle) {
            return (angle * Math.PI) / 180;
        },
        drawFillCircle(ctx, x, y, size, color) {
            ctx.beginPath();
            ctx.fillStyle = color;
            ctx.arc(x, y, size, 0, 2 * Math.PI);
            ctx.fill();
        },
        drawEmptyCircle(ctx, x, y, size, color) {
            ctx.beginPath();
            ctx.strokeStyle = color;
            ctx.arc(x, y, size, 0, 2 * Math.PI);
            ctx.stroke();
        },
        drawArcCircle(ctx, x, y, radius) {
            ctx.beginPath();
            ctx.arc(x, y, radius, 0, 2 * Math.PI);
            ctx.strokeStyle = "black";
            ctx.stroke();
        },
        drawCaboLabel(ctx, text, x, y, dotRadius) {
            const label = String(text);
            const diameter = dotRadius * 2;
            let fontSize = 14;
            ctx.font = `${fontSize}px Arial`;
            const textWidth = ctx.measureText(label).width;
            if (textWidth > diameter * 0.9) {
                fontSize = (fontSize * diameter * 0.9) / textWidth;
            }
            this.drawText(ctx, label, x, y, fontSize);
        },
        agruparPorArco(data, incluirCentral) {
            const cabosPorArco = {};
            data.forEach((obj) => {
                if (!incluirCentral && obj.arco === 999) return;
                if (!cabosPorArco[obj.arco]) {
                    cabosPorArco[obj.arco] = [];
                }
                cabosPorArco[obj.arco].push(obj);
            });
            return cabosPorArco;
        },
        prepararCanvas(canvas, larguraLogica, alturaLogica) {
            const ctx = canvas.getContext("2d");
            const scale = Math.min(window.devicePixelRatio || 1, 2);
            const w = Math.round(larguraLogica * scale);
            const h = Math.round(alturaLogica * scale);
            if (canvas.width !== w || canvas.height !== h) {
                canvas.width = w;
                canvas.height = h;
            }
            ctx.setTransform(scale, 0, 0, scale, 0, 0);
            ctx.clearRect(0, 0, larguraLogica, alturaLogica);
            return ctx;
        },
        renderVistaSuperior(cabos) {
            // Verificar se cabos é um array com itens
            if (!Array.isArray(cabos) || cabos.length === 0) {
                return;
            }

            if (this.silotipo == "silo") {
                this.renderSilo(cabos);
            } else {
                this.renderArmazem(cabos);
            }
        },
        renderSilo(data) {
            const LARGURA = 350;
            const ALTURA = 350;
            const DOT_R = 12;
            const canvas = this.$refs.canvasVistaSuperior;
            const ctx = this.prepararCanvas(canvas, LARGURA, ALTURA);
            this.tamanhoLogico = { largura: LARGURA, altura: ALTURA };
            this.hitAreas = [];
            const bluecolor = "#33B35A";

            const centerX = LARGURA / 2;
            const centerY = ALTURA / 2;
            const radius = 150;

            ctx.fillStyle = this.theme === 'dark' ? '#1A1D21' : 'white';
            ctx.fillRect(0, 0, LARGURA, ALTURA);

            const cabosPorArco = this.agruparPorArco(data, true);
            const arcos = Object.keys(cabosPorArco)
                .map(Number)
                .filter((a) => a !== 999)
                .sort((a, b) => a - b);
            const quantidadeArcosUnicos = arcos.length || 1;

            this.drawFillCircle(ctx, centerX, centerY, radius, (this.theme === 'dark' ? '#334155' : '#E9EEF6'));

            ctx.beginPath();
            ctx.rect(centerX - 25, centerY + 125, 60, 30);
            ctx.fill();

            const valueByRadius = radius / (quantidadeArcosUnicos + 1);
            let currentRadius = radius;

            const drawArc = (arcoRadius, cabosArco, anguloInicial = 70) => {
                const totalCabos = cabosArco.length;
                if (totalCabos === 0) return;
                const anguloInc = -360 / totalCabos;

                for (let i = 0; i < totalCabos; i++) {
                    const angulo = anguloInicial + i * anguloInc;
                    const radians = this.degreeToRadians(angulo);
                    const x = Math.cos(radians) * arcoRadius + centerX;
                    const y = Math.sin(radians) * arcoRadius + centerY;

                    const item = cabosArco[i];
                    this.drawCabo(ctx, item.cabo ?? item, x, y, DOT_R, bluecolor);
                }
            };

            if (cabosPorArco[999] !== undefined) {
                drawArc(0, cabosPorArco[999]);
            }

            // Arco 1 começa um pouco à direita da escada; cada arco seguinte começa no
            // espaço livre entre os cabos do arco anterior (meio passo adiante).
            let anguloInicial = 70;
            arcos.forEach((arco, idx) => {
                if (idx > 0) {
                    const anterior = cabosPorArco[arcos[idx - 1]].length;
                    if (anterior > 0) anguloInicial -= 180 / anterior;
                }
                currentRadius -= valueByRadius;
                this.drawArcCircle(ctx, centerX, centerY, currentRadius);
                drawArc(currentRadius, cabosPorArco[arco], anguloInicial);
            });
        },
        renderArmazem(data) {
            const LARGURA = 350;
            const DOT_R = 10;
            const MARGIN = 20;
            const MIN_ROW = 2 * DOT_R + 2;
            const ALTURA_BASE = 350;

            const bluecolor = "#33B35A";

            const cabosPorArco = this.agruparPorArco(data, false);
            const arcos = Object.keys(cabosPorArco)
                .map(Number)
                .sort((a, b) => a - b);
            const nArcos = arcos.length;
            if (nArcos === 0) return;
            const espacoDisponivel = ALTURA_BASE - 2 * MARGIN;
            const rowSpacing = Math.max(MIN_ROW, espacoDisponivel / (nArcos + 1));
            const ALTURA = Math.max(ALTURA_BASE, rowSpacing * (nArcos + 1) + 2 * MARGIN);

            const canvas = this.$refs.canvasVistaSuperior;
            const ctx = this.prepararCanvas(canvas, LARGURA, ALTURA);
            this.tamanhoLogico = { largura: LARGURA, altura: ALTURA };
            this.hitAreas = [];
            ctx.fillStyle = this.theme === 'dark' ? '#1A1D21' : 'white';
            ctx.fillRect(0, 0, LARGURA, ALTURA);
            ctx.fillStyle = this.theme === 'dark' ? '#334155' : '#BCBEBC';
            ctx.fillRect(20, 10, 310, ALTURA - 20);

            let maxPos = 0;
            data.forEach((c) => {
                const p = Number(c.posicao);
                if (!Number.isNaN(p) && p > maxPos) maxPos = p;
            });
            if (maxPos < 1) maxPos = 1;
            const left = 20;
            const caboSpacingX = 310 / (maxPos + 1);
            const totalSpan = rowSpacing * (nArcos - 1);
            const startY = (ALTURA - totalSpan) / 2;

            ctx.strokeStyle = 'black';
            ctx.lineWidth = 1;

            arcos.forEach((arco, idx) => {
                const linhaY = startY + rowSpacing * idx;
                ctx.beginPath();
                ctx.moveTo(20, linhaY);
                ctx.lineTo(330, linhaY);
                ctx.stroke();

                cabosPorArco[arco].forEach((cabo) => {
                    const p = Number(cabo.posicao);
                    if (Number.isNaN(p)) return;
                    const x = left + caboSpacingX * p;
                    this.drawCabo(ctx, cabo.cabo, x, linhaY, DOT_R, bluecolor);
                });
            });
        },
    },
};
</script>

<style scoped>
.canvas-container {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    margin-top: 15px;
}

.canvas-viewport {
    width: 100%;
    max-width: 350px;
    max-height: 480px;
    overflow-y: auto;
    overflow-x: hidden;
    border-radius: 15px;
}

canvas {
    display: block;
    width: 100%;
    height: auto;
    border: none;
    border-radius: 15px;
}

.canvas-viewport::-webkit-scrollbar {
    width: 8px;
}
.canvas-viewport::-webkit-scrollbar-thumb {
    background: rgba(148, 163, 184, 0.5);
    border-radius: 8px;
}
.canvas-viewport::-webkit-scrollbar-track {
    background: transparent;
}
.custom-scrollbar::-webkit-scrollbar { width: 4px; }
.custom-scrollbar::-webkit-scrollbar-track { background: transparent; }
.custom-scrollbar::-webkit-scrollbar-thumb { background: #33b35a; border-radius: 10px; }
</style>
